var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCaseTech6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 44,
    viewBox: "0 0 42 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_781_4893)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8996 0H25.3513V31.4571C22.0466 32.1221 19.6138 32.3838 16.9816 32.3838C9.10181 32.375 5 28.63 5 21.4375C5 14.5075 9.3509 10.01 16.0932 10.01C17.1394 10.01 17.9364 10.0976 18.8996 10.36V0ZM19.1257 16.0289C18.3701 15.7664 17.7474 15.6789 16.9503 15.6789C13.6871 15.6789 11.8023 17.7964 11.8023 21.5072C11.8023 25.1201 13.6042 27.1151 16.9088 27.1151C17.6228 27.1151 18.2041 27.0723 19.1257 26.941V16.0289Z",
    fill: "#2BA977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9007 10.8545V26.6047C35.9007 32.0287 35.5188 34.6371 34.3978 36.886C33.3516 39.048 31.9733 40.4113 29.1253 41.9171L23.1387 38.9159C25.9867 37.5079 27.365 36.2637 28.2452 34.365C29.1667 32.4234 29.4573 30.1746 29.4573 24.2596V10.8547H35.9007V10.8545ZM28.8072 0H35.2588V6.97377H28.8072V0Z",
    fill: "#2BA977"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_781_4893"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 42,
    fill: "white",
    transform: "translate(5)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaseTech6);
export default __webpack_public_path__ + "static/media/case_tech6.098b89e7c4ddba5604545524c6f1b3b0.svg";
export { ForwardRef as ReactComponent };